export { default as ResetPasswordSent } from './ResetPasswordSent';
